import styled from '@emotion/styled';
import type { FC } from 'react';
import { RacemapLogo } from '../BasicComponents/RacemapLogo';

export const LeaderboardFooter: FC = () => {
  return (
    <Container>
      <RacemapLogo height={40} />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
`;
